import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {PageDescription, Row, Column, ExternalLink, Feedback, AnchorLink, AnchorLinks, BitcoinMiningUrlsV1, BitcoinMiningUrlsV2} from 'components';
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    em: "em",
    h2: "h2",
    li: "li",
    p: "p",
    strong: "strong",
    table: "table",
    tbody: "tbody",
    td: "td",
    th: "th",
    thead: "thead",
    tr: "tr",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(PageDescription, {
      children: _jsx(_components.p, {
        children: "Figure out how to connect to Braiins Pool by following these steps:"
      })
    }), "\n", _jsxs(AnchorLinks, {
      children: [_jsx(AnchorLink, {
        children: "Get suitable hardware"
      }), _jsx(AnchorLink, {
        children: "Sign-up for a Braiins Pool account"
      }), _jsx(AnchorLink, {
        children: "Configure your mining device"
      }), _jsx(AnchorLink, {
        children: "Register your payout address"
      }), _jsx(AnchorLink, {
        children: "Check if you are mining"
      })]
    }), "\n", _jsx(_components.h2, {
      children: "Get suitable hardware"
    }), "\n", _jsx("div", {
      style: {
        marginTop: '1em'
      },
      children: _jsxs(_components.p, {
        children: [_jsx("span", {
          style: {
            color: 'green',
            margin: '0 1em 0 0'
          },
          children: "✓"
        }), " Bitcoin can be efficiently mined with: ASIC (SHA-256 algorithm)"]
      })
    }), "\n", _jsx("div", {
      style: {
        marginTop: '1em'
      },
      children: _jsxs(_components.p, {
        children: [_jsx("span", {
          style: {
            color: 'red',
            margin: '0 1em 0 0'
          },
          children: "✘"
        }), " Bitcoin cannot be efficiently mined with (unsupported): GPU, CPU, mobile phone"]
      })
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.em, {
        children: "While mining with unsupported hardware might be possible, it will almost certainly be unprofitable. Also, keep in mind that our support team will not be resolving issues related to unsupported hardware."
      })
    }), "\n", _jsx(_components.h2, {
      children: "Sign-up for a Braiins Pool account"
    }), "\n", _jsx(_components.p, {
      children: "You can use an existing account if you have one."
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "https://pool.braiins.com/signup/",
          children: "Sign-up"
        }), " to the pool, wait for the confirmation email and ", _jsx(_components.a, {
          href: "https://pool.braiins.com/login/",
          children: "log into"
        }), " your account."]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      children: "Configure your mining device"
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.em, {
        children: "Individual hardware manufacturers may have specific settings requirements and different settings interfaces. Please follow their official documentation when setting up your miners. This also applies to cloud mining services."
      })
    }), "\n", _jsxs(_components.p, {
      children: ["The login credentials needed for your miner look like this (please change ", _jsx(_components.code, {
        children: "userName"
      }), " and ", _jsx(_components.code, {
        children: "workerName"
      }), " according to your account information):"]
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "Parameter"
          }), _jsx(_components.th, {
            children: "Value"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "URL"
          }), _jsxs(_components.td, {
            children: ["stratum+tcp://stratum.braiins.com:3333 (443, 3336)", _jsx("br", {}), "(Braiins OS 22.08 and older see below)"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "User ID"
          }), _jsx(_components.td, {
            children: "userName.workerName"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Password"
          }), _jsx(_components.td, {
            children: "anything (or empty)"
          })]
        })]
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["Remember to configure the credentials for each device. The ", _jsx(_components.code, {
        children: "User ID"
      }), " is mandatory and is used to pair the device with your account. Password is not used, it can be anything. User ID consists of ", _jsx(_components.code, {
        children: "userName"
      }), " (same as your account name) and ", _jsx(_components.code, {
        children: "workerName"
      }), " (any device identifier). If ", _jsx(_components.code, {
        children: "workerName"
      }), " is empty, ", _jsx(_components.code, {
        children: "[auto]"
      }), " worker is created for you. We recommend connecting each mining device with a separate workerName for efficient monitoring."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.strong, {
        children: "Only one URL is now used by our Pool."
      }), " Braiins Pool servers are located all around the world and automatically selected based on your location. For best efficiency we advise stop using location-specific URLs used in the past (e.g. Europe, USA, Canada, Brazil, Singapore, Russia, etc.)."]
    }), "\n", _jsx(_components.p, {
      children: "Set old slushpool.com address (stratum.slushpool.com) if you’re using Braiins OS version older than 22.08.1 for successful application of 0% mining fee on Braiins Pool."
    }), "\n", _jsx(_components.h2, {
      children: "Stratum V2"
    }), "\n", _jsxs(_components.p, {
      children: ["For Stratum V2 connection guide see the ", _jsx(_components.a, {
        href: "/en/braiins-pool/stratum-v2-manual/",
        children: "Stratum V2 manual section"
      }), ". You need to run our ", _jsx(ExternalLink, {
        href: "https://braiins.com/os/plus",
        text: "Braiins OS"
      }), " firmware which supports Stratum V2 (stock manufacturing firmware currently does not support this new protocol)."]
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "Parameter"
          }), _jsx(_components.th, {
            children: "Value"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "URL"
          }), _jsxs(_components.td, {
            children: ["stratum2+tcp://v2.stratum.braiins.com/u95GEReVMjK6k5YqiSFNqqTnKU4ypU2Wm8awa6tmbmDmk1bWt", _jsx("br", {}), "(Braiins OS 22.08 and older use slushpool.com)"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "User ID"
          }), _jsx(_components.td, {
            children: "userName.workerName"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Password"
          }), _jsx(_components.td, {
            children: "anything (or empty)"
          })]
        })]
      })]
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.strong, {
        children: "Example configuration"
      })
    }), "\n", _jsx(_components.p, {
      children: "Let’s say there is a miner with username bigMiner and his worker is named strongDevice. The configuration information for this miner would look like the following (configure accordingly):"
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "Parameter"
          }), _jsx(_components.th, {
            children: "Value"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "URL"
          }), _jsx(_components.td, {
            children: "stratum+tcp://stratum.braiins.com:3333"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "User ID"
          }), _jsx(_components.td, {
            children: "bigMiner.strongDevice"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Password"
          }), _jsx(_components.td, {
            children: "anything123"
          })]
        })]
      })]
    }), "\n", _jsx(_components.h2, {
      children: "Register your payout address"
    }), "\n", _jsxs(_components.p, {
      children: ["To collect your reward you have to set up a payout address in the ", _jsx(_components.em, {
        children: "Funds > Wallets menu"
      }), " and define a payout rule in the ", _jsx(_components.em, {
        children: "Funds > Account detail"
      }), ". Once you reach the minimum threshold, your rewards will be sent there. You can start mining even without this address being registered, but it is highly recommended that you register it straight away."]
    }), "\n", _jsxs(_components.p, {
      children: ["If you do not have an address yet, you need to get a wallet first. We recommend the Trezor Hardware Wallet for maximum security. Other usable wallets are listed on ", _jsx(_components.a, {
        href: "https://bitcoin.org/en/choose-your-wallet",
        children: "Bitcoin.org"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["Alternatively, if you decide to use Lightning payouts instead, you can do so with Braiins Pool. Make sure to use a ", _jsx(_components.a, {
        href: "https://coincharge.io/en/lnurl-for-lightning-wallets/",
        children: "Lightning wallet"
      }), " which is capable of providing a ", _jsx(_components.a, {
        href: "https://coincharge.io/en/lightning-address/",
        children: "Lightning address"
      }), " to you. Lightning payouts requested via invoice are not supported."]
    }), "\n", _jsx(_components.h2, {
      children: "Check if you are mining"
    }), "\n", _jsxs(_components.p, {
      children: ["Open your Dashboard on the Mining tab for the coin that you are mining. Then check your hash rate in the Recent Hash Rate graph section below. Please be patient; it can take up to an hour until you see the full hashing power of your newly connected device. You can also look through our article “How to check if I’m mining” in ", _jsx(_components.a, {
        href: "/en/braiins-pool/faqs/mining-basics/#how-to-check-if-im-mining",
        children: "Troubleshooting section"
      }), "."]
    }), "\n", _jsx(Feedback, {})]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
